import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AuthService } from "./../../services/auth.service";
import { Router } from "@angular/router";
import { DaoService } from "./../../services/dao.service";
import { LstorageService } from "./../../services/lstorage.service";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";

import * as jwtDecode from "jwt-decode";
import { ToastService } from "src/app/services/toast.service";
import { decryptData, encryptData } from "src/app/services/aes.service";

export interface Country {
  name: string;
  code: string;
  img: string;
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @ViewChild("ngOtpInputs", { static: true }) ngOtpInputs: any;

  submitted = false;
  phonenumber = "";
  country = "";
  otp: number;
  otpflag = false;
  otperrormsg = "";
  errorMsg: any;
  public isBeforeOtp = false;
  public otpverified = false;
  private authenticated = false;
  private userRole: string;
  verificationSent = false;
  verificationSuccess = false;
  verificationCode: string = "";
  otpvalue: number;
  public otpconfig = {
    allowNumbersOnly: true,
    disableAutoFocus: false,
    length: 4,
    inputStyles: {
      width: "66px",
      height: "50px",
      color: "var(--themecolor)",
    },
  };

  countrycodes: Country[] = [
    { name: "India", code: "+91", img: "assets/img/Flag-India.jpg" },
    { name: "UAE", code: "+971", img: "assets/img/Flag-UAE.png" },
    { name: "USA", code: "+1", img: "assets/img/flag-usa.png" },
    { name: "UK", code: "+61", img: "assets/img/flag-aus.jpg" },
  ];

  public ShowMobileScreen = true;
  public ShowOtpScreen = false;
  public ShowResultScreen = false;
  public islight = false;

  public loginForm: FormGroup = new FormGroup({
    countrycode: new FormControl("", [Validators.required]),
    mobile: new FormControl("", [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(10),
      Validators.pattern("[0-9]+$"),
    ]),
  });

  constructor(
    private authService: AuthService,
    private route: Router,
    private daoService: DaoService,
    private token: LstorageService,
    private spinner: SpinnerService,
    public toastservice: ToastService
  ) {
    if (token.getTheme()) {
      var theme = token.getTheme().lightbg;
      if (token.getTheme().lightbg.includes("f6f9fb")) {
        this.islight = true;
      }
    }
  }

  ngOnInit() {}

  funcShowMobileScreen() {
    debugger;
    this.ShowMobileScreen = true;
    this.ShowOtpScreen = false;
    this.ShowResultScreen = false;
    this.otpverified = false;
    this.otpflag = false;
    this.otperrormsg = "";
  }

  funcShowOtpScreen() {
    debugger;
    this.ShowMobileScreen = false;
    this.ShowOtpScreen = true;
    this.ShowResultScreen = false;

    this.otpverified = false;
    this.otpflag = false;
    this.otperrormsg = "";
  }

  funcShowResultScreen() {
    debugger;
    this.ShowMobileScreen = false;
    this.ShowOtpScreen = false;
    this.ShowResultScreen = true;
  }

  // funcOnMobileNumberSubmit() {
  //   // stop here if form is invalid
  //   if (this.loginForm.invalid) {
  //     return;
  //   } else {
  //     this.submitted = true;
  //     this.spinner.show();
  //     this.daoService
  //       .sendOtp(
  //         this.loginForm.get('countrycode').value,
  //         this.loginForm.get('mobile').value
  //       )
  //       .subscribe(
  //         (data: any) => {
  //           if (data.isSuccess) {
  //             this.authenticated = true;
  //             this.phonenumber = this.loginForm.get('mobile').value;
  //             this.country = this.loginForm.get('countrycode').value;
  //             this.spinner.hide();
  //             this.funcShowOtpScreen();
  //             this.startTimer();
  //           } else {
  //             this.spinner.hide();
  //             this.isBeforeOtp = true;
  //             this.otpflag = false;
  //             this.errorMsg = data.message;
  //             this.funcShowResultScreen();
  //           }
  //         },
  //         (error) => {
  //           console.log('Error: ' + error.error.userMessage);
  //           this.otpverified = false;
  //           this.otpflag = false;
  //           this.errorMsg = error.error.userMessage;
  //           this.isBeforeOtp = true;
  //           this.spinner.hide();
  //           this.funcShowResultScreen();
  //         }
  //       );
  //   }
  // }

  timeLeft: number = 30;
  interval;
  timer: boolean = false;
  otpExpired: boolean = false;

  startTimer() {
    debugger;
    this.timeLeft = 60;
    clearInterval(this.interval);
    this.timer = true;

    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timer = false;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  ResendOtp() {
    if (this.ngOtpInputs) {
      this.ngOtpInputs.setValue("");
    }

    let formData = {
      phoneNumber: this.loginForm.get("mobile").value,
    };
    console.log("submit called");
    this.daoService
      .SendOTP(encryptData(JSON.stringify(formData)))
      .subscribe((data: any) => {
        if (this.otp) {
          //.log(this.ngOtpInput);
          //  this.ngOtpInput.setValue("");//yourvalue can be any string or number eg. 1234 or '1234'
        }

        this.otpExpired = false;
        this.startTimer();
      });
  }

  // funcVerifyOtp() {
  //   this.isBeforeOtp = false;
  //   if (this.timer) {
  //     var OtpForm = {
  //       //  country: this.country,
  //       PhoneNumber: this.phonenumber,
  //       OTP: this.otp,
  //     };
  //     this.spinner.show();
  //     this.daoService.VerifyOTP(encryptData(JSON.stringify(OtpForm))).subscribe(
  //       (res: any) => {
  //          console.log("OTP verification response received:", res);
  //         debugger;
  //         console.log("otp back!!!!!");
  //         if (res.isOk) {
  //           debugger;
  //           let message = JSON.parse(decryptData(res.key));
  //           console.log("otp verified!!!!!");
  //           this.spinner.hide();
  //           this.timer = false;
  //           this.timeLeft = 120;
  //           var decoded = jwtDecode(message.token);
  //           this.token.saveToken(message.token, decoded.role);
  //           this.otperrormsg = "";
  //           this.authService.auth(this.otp);
  //           this.otpverified = true;
  //           this.funcShowResultScreen();
  //         } else {
  //           this.spinner.hide();
  //           this.otpverified = false;
  //           this.otpflag = false;
  //           this.errorMsg = "Invalid OTP. Please enter valid OTP";
  //           this.funcShowResultScreen();
  //         }
  //       },
  //       (error) => {
  //         this.spinner.hide();
  //         this.errorMsg = error.error.userMessage;
  //         this.otpverified = false;
  //         this.otpflag = false;

  //         this.funcShowResultScreen();
  //       }
  //     );
  //   } else {
  //     this.otpExpired = true;
  //     this.errorMsg = "Otp is Expired";
  //   }
  // }

  funcVerifyOtp() {
    this.isBeforeOtp = false;
    if (this.timer) {
      const OtpForm = {
        PhoneNumber: this.phonenumber,
        OTP: this.otp,
      };
      this.spinner.show();
      this.daoService.VerifyOTP(encryptData(JSON.stringify(OtpForm))).subscribe(
        (res: any) => {
          console.log("OTP verification response received:", res); // Log the response
          if (res.isOk) {
            debugger;
            try {
              const decryptedKey = decryptData(res.key);
              console.log("Decrypted response:", decryptedKey); // Log the decrypted response
              const message = JSON.parse(decryptedKey);
              console.log("OTP verified:", message); // Log the parsed message
              this.spinner.hide();
              this.timer = false;
              this.timeLeft = 120;
              console.log("UserToken", message.Key);
              const decoded = jwtDecode(message.Key);
              this.daoService.decodeJWT(message.Key);
              let user = this.daoService.loggedUser;
              //           this.token.saveToken(message.token, decoded.role);
              console.log("Decoded JWT:", decoded); // Log the decoded JWT

              const roleClaim =
                "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
              const userRole = decoded[roleClaim]; // Access the role using the full claim URI

              this.token.saveToken(message.Key, userRole);
              //     this.token.saveToken(message.Key, decoded.role);
              this.otperrormsg = "";
              this.authService.auth(this.otp);
              this.otpverified = true;
              this.funcShowResultScreen();
            } catch (error) {
              console.error("Error decoding token:", error); // Log the error
              this.spinner.hide();
              this.otpverified = false;
              this.errorMsg = "Invalid token specified";
              this.funcShowResultScreen();
            }
          } else {
            this.spinner.hide();
            this.otpverified = false;
            this.otpflag = false;
            this.errorMsg = "Invalid OTP. Please enter valid OTP";
            this.funcShowResultScreen();
          }
        },
        (error) => {
          this.spinner.hide();
          this.errorMsg = error.error.userMessage;
          this.otpverified = false;
          this.otpflag = false;
          this.funcShowResultScreen();
        }
      );
    } else {
      this.otpExpired = true;
      this.errorMsg = "Otp is Expired";
    }
  }

  keyDownFunctionOnVerifyOtp(event) {
    if (event.keyCode === 13) {
      this.funcVerifyOtp();
    }
  }

  // funcShowDashboard() {
  //   // this.route.navigate(["/Dashboard"]);
  //   this.route.navigate(["/ApiGroup"]);
  // }
  funcShowDashboard() {
    if (this.token.getRole().includes("Admin")) {
      this.route.navigate(["/ApiGroup"]);
    } else {
      this.route.navigate(["/Dashboard"]);
    }
  }
  // funcShowDashboard() {
  //   debugger;
  //   //  if (this.token.getRole().includes("Admin")) {
  //   //   this.route.navigate(["/ApiGroup"]);
  //   // } else {
  //   this.route.navigate(["/ApiGroup"]);
  //   // }
  // }
  onOtpChange(otp) {
    debugger;
    this.otp = +otp; // + for parseInt
    if (this.otp.toString().length === 4) {
      this.otpflag = true;
    } else {
      this.otpflag = false;
    }
  }

  allowOnlyNubers(event) {
    debugger;
    if (
      !(
        (event.keyCode > 95 && event.keyCode < 106) ||
        (event.keyCode > 47 && event.keyCode < 58) ||
        event.keyCode === 8
      )
    ) {
      return false;
    }
  }
  onSubmit() {
    debugger;
    if (this.loginForm.invalid) {
      return;
    } else {
      this.submitted = true;
      this.spinner.show();
      let formData = {
        phoneNumber: this.loginForm.get("mobile").value,
        // password: encryptData(this.loginForm.value.password)
      };
      console.log("submit called");
      this.daoService.SendOTP(encryptData(JSON.stringify(formData))).subscribe(
        (res: any) => {
          debugger;
          let message = JSON.parse(decryptData(res.key));
          console.log("response!!!");
          if (message.isOk) {
            debugger;
            console.log("response111!!!");
            this.authenticated = true;
            this.phonenumber = this.loginForm.get("mobile").value;
            this.country = this.loginForm.get("countrycode").value;
            this.spinner.hide();
            this.funcShowOtpScreen();
            this.startTimer();
          } else {
            this.spinner.hide();
            this.isBeforeOtp = true;
            this.otpflag = false;
            this.errorMsg = res.message;
            this.funcShowResultScreen();
          }
        },
        (error) => {
          console.log("Error: " + error.error.userMessage);
          this.otpverified = false;
          this.otpflag = false;
          this.errorMsg = error.error.userMessage;
          this.isBeforeOtp = true;
          this.spinner.hide();
          this.funcShowResultScreen();
        }
      );
    }
  }
}
